import {
  getObjectLength, stringOperation,
} from './util';
import { extractMapResponseValueByKey } from './conditionEvaluator';

const getVal = require('lodash/get');
const setVal = require('lodash/set');
const unSetVal = require('lodash/unset');

const dynamicVariableMappings = [{
  key: 'fieldDynamicDisplay',
  settingKey: 'fieldIndicator',
  compareValue: 'show',
  truthyValue: true,
  falsyValue: false,
}, {
  key: 'fieldDynamicRequired',
  settingKey: 'fieldValidation.required',
  compareValue: 'required',
  truthyValue: true,
  falsyValue: false,
}, {
  key: 'fieldDynamicDisable',
  settingKey: 'fieldValidation.disabled',
  compareValue: 'disable',
  truthyValue: true,
  falsyValue: false,
}, {
  key: 'fieldDynamicLabel',
  settingKey: 'fieldIndicator',
  compareValue: '',
  truthyValue: false,
  falsyValue: true,
}, {
  key: 'fieldDynamicChangeValue',
  settingKey: 'isChangePageValue',
  compareValue: 'yes',
  truthyValue: true,
  falsyValue: false,
}];

/* eslint-disable max-len -- need */
/* eslint-disable max-params -- need */
const extractMapResponseByDynamicKeys = (childEl, objectOfFunctions, formContainer, currentPayload, currentFiles, currentS3Files, currentEntityPayload, currentDisabledButtons) => {
  let mapResponseValue;

  dynamicVariableMappings.forEach((mapping) => {
    mapResponseValue = extractMapResponseValueByKey(childEl, mapping.key, objectOfFunctions, formContainer, currentPayload, currentDisabledButtons);
    if (mapResponseValue) {
      if (mapping.key === 'fieldDynamicLabel') {
        setVal(childEl, 'fieldLabel', mapResponseValue);
      }
      if (mapResponseValue === mapping.compareValue) {
        setVal(childEl, mapping.settingKey, mapping.truthyValue);
      } else {
        if (mapping.key === 'fieldDynamicDisplay') {
          if (childEl.removeIdFromPayload) {
            if (childEl.fieldId && Object.prototype.hasOwnProperty.call(currentPayload, childEl.fieldId)) {
              delete currentPayload[childEl.fieldId];
            } else if (childEl.fieldName && Object.prototype.hasOwnProperty.call(currentPayload, childEl.fieldName)) {
              delete currentPayload[childEl.fieldName];
            }
          } else if (childEl.removeIdsFromPayload) {
            childEl.removeIdsFromPayload.forEach((id) => {
              if (currentPayload[id]) delete currentPayload[id];
            });
          } else if (childEl.removeEntityFromPayload && childEl.showId) {
            delete currentEntityPayload[childEl.showId];
          }
          if (childEl.fieldType === 'attachFilesToPayload') {
            if (!childEl.isS3Upload && currentFiles.length > 0) {
              let i = currentFiles.length - 1;
              while (i >= 0) {
                const fileObj = currentFiles[i];
                if (fileObj.fileFrom === childEl.fieldId) {
                  currentFiles.splice(i, 1);
                }
                i -= 1;
              }
            }
            if (childEl.isS3Upload && currentS3Files.length > 0) {
              let i = currentS3Files.length - 1;
              while (i >= 0) {
                const fileObj = currentS3Files[i];
                if (fileObj.fileFrom === childEl.fieldId) {
                  currentS3Files.splice(i, 1);
                }
                i -= 1;
              }
            }
          }
          // if this element has buttons to control
          if (childEl.buttonsToDisable && childEl.buttonsToDisable.length > 0) {
            childEl.buttonsToDisable.forEach((btnId) => {
              if (currentDisabledButtons[btnId]
                && currentDisabledButtons[btnId][childEl.fieldId]) {
                delete currentDisabledButtons[btnId][childEl.fieldId];
                if (getObjectLength(currentDisabledButtons[btnId]) === 0) {
                  delete currentDisabledButtons[btnId];
                }
              }
            });
          }
        }
        setVal(childEl, mapping.settingKey, mapping.falsyValue);
      }
    }
  });
};

/* eslint complexity: ["error", 80] -- need to increase complexity */
const iterateChildElements = (childElement, currentPayload, currentFiles, currentDisabledButtons, currentS3Files, currentEntityPayload, objectOfFunctions, formContainer) => {
  let childObjects = ['childElements'];
  childObjects = childElement?.evaluateChildren?.length > 0 ? [...childObjects, ...childElement.evaluateChildren] : childObjects;
  // see if childElement has childElements or popUpBodyChildElements and iterate over them
  childObjects.forEach((childObj) => {
    if (childElement && childElement[childObj] && childElement[childObj].length > 0) {
      childElement[childObj].forEach((childEl) => {
        /** Replace ## values */
        if (childEl.mapReplaceItems && childEl.mapReplaceItems.length > 0) {
          if (childEl.stringToReplace) {
            let newString = childEl.stringToReplace;
            childEl.mapReplaceItems.forEach((row) => {
              const val = getVal(objectOfFunctions, row.value);
              if (val) newString = newString.replace(row.key, val);
            });
            const replaced = newString !== childEl.stringToReplace;
            if (replaced && childEl.replaceWith !== '') {
              setVal(childEl, childEl.replaceWith, newString);
            }
          } else {
            childEl.mapReplaceItems.forEach((row) => {
              if (row.replace) {
                const existingValue = getVal(childEl, row.replace);
                if (existingValue) {
                  let fetchedValue = getVal(objectOfFunctions, row.value);
                  if (row.operation) {
                    fetchedValue = stringOperation(row.operation, fetchedValue);
                  }
                  const newValue = existingValue.replace(row.key, fetchedValue);
                  setVal(childEl, row.replace, newValue);
                }
              } else if (row.replacePath) {
                const existingValue = getVal(childEl, row.replacePath);
                if (existingValue) {
                  let fetchedValue = getVal(objectOfFunctions, row.value);
                  if (row.operation) {
                    fetchedValue = stringOperation(row.operation, fetchedValue);
                  }
                  const newKeyPath = row.replacePath.map((path) => path.replace(row.key, fetchedValue));
                  setVal(childEl, newKeyPath, existingValue);
                  unSetVal(childEl, row.replacePath);
                }
              } else {
                childEl.fieldValue = childEl.fieldValue.replace(
                  row.key,
                  getVal(objectOfFunctions, row.value)
                );
              }
            });
          }
        }
        extractMapResponseByDynamicKeys(childEl, objectOfFunctions, formContainer, currentPayload, currentFiles, currentS3Files, currentEntityPayload, currentDisabledButtons);

        if (childEl.childElements || childEl?.evaluateChildren?.length > 0) {
          iterateChildElements(childEl, currentPayload, currentFiles, currentDisabledButtons, currentS3Files, currentEntityPayload, objectOfFunctions, formContainer);
        }
      });
    }
  });
  return childElement;
};
/* eslint-enable max-params -- need */
/* eslint-enable max-len -- need */

export { iterateChildElements };
